//system
import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
//import { latLng, tileLayer, marker, icon, Map } from 'leaflet';
import { Map, Control, DomUtil, MapOptions, tileLayer, latLng, marker, icon } from 'leaflet';
import * as L from 'leaflet';

//services
import { MapRendererService } from '../../services/map-renderer.service';
import { RenderAndPreviewControllerService } from "../../services/render-and-preview-controller.service";
import { ClearDataService } from "../../services/clear-data.service";



// interfaces
import { PostOfficeInfo } from 'src/app/interfaces/post-office-info.interface';



@Component({
  selector: 'map-container',
  templateUrl: './map-container.component.html',
  styleUrls: ['./map-container.component.sass'],
  animations: [
    trigger('scaleWidth', [

      state('wide', style({
        width: '100%'
      })),
      state('thin', style({
        width: 'calc(100% - 350px)'
      })),
      transition('thin => wide', [
        animate('200ms')
      ]),
      transition('wide => thin', [
        animate('200ms')
      ]),
    ]),
    trigger('openClosePreview', [

      state('open', style({
        width: '350px'
      })),
      state('close', style({
        width: '0%'
      })),
      transition('open => close', [
        animate('200ms')
      ]),
      transition('close => open', [
        animate('200ms')
      ]),
    ]),
  ]
})
export class MapContainerComponent implements OnInit {

  public isDisplayError: boolean = false;
  public map: L.Map;
  public fullscreenOptions: { [key: string]: any } = {
    position: 'topleft',
    pseudoFullscreen: false,
    title: {
      true: 'Exit Fullscreen',
      false: 'View Fullscreen',
    }

  }
  
  public currentOffices: Array<PostOfficeInfo>;

  public currentVPZ: Array<any>;

  private currentScaledUpMarker: any;

  // NEW PINS MAPPING
  private pinsImgURLs = {
    miske: {
      active: 'assets/img/pins/miske-active.svg',
      inactive: 'assets/img/pins/miske-inactive.svg'
    },
    peresuvne: {
      active: 'assets/img/pins/peresuvne-active.svg',
      inactive: 'assets/img/pins/peresuvne-inactive.svg'
    },
    vantazhne: {
      active: 'assets/img/pins/vantazhne-active.svg',
      inactive: 'assets/img/pins/vantazhne-inactive.svg'
    },
    poshtomat: {
      active: 'assets/img/pins/poshtomat-active.svg',
      inactive: 'assets/img/pins/poshtomat-inactive.svg'
    },
    pudo: {
      active: 'assets/img/pins/pudo-active.svg',
      inactive: 'assets/img/pins/pudo-inactive.svg'
    }
  };

  private getPinTypeByOffice(office: PostOfficeInfo): string {
    if (office.IS_POSHTOMAT === '1') return 'poshtomat';
    if (office.IS_PUDO === '1') return 'pudo';
    if (office.CARGO === '1') return 'vantazhne'; 
    if (office.TYPE_ACRONYM === 'ПВ') return 'peresuvne';
    
    return 'miske'; // Дефолтне міське відділення
  }

  private iconSize = {
    width: 40,
    height: 50
  }

  private iconSizeScaledUP = {
    width: 70,
    height: 90
  }

  private standartMarkers: { 'letter': L.Marker, 'circle': L.Marker, 'dots': L.Marker } = {
    letter:
      marker([0, 0], {
        icon: icon({
          iconSize: [this.iconSize.width, this.iconSize.height],
          iconAnchor: [25, 50],
          iconUrl: this.pinsImgURLs['letterPin'],
        })
      }),
    circle:
      marker([0, 0], {
        icon: icon({
          iconSize: [this.iconSize.width, this.iconSize.height],
          iconAnchor: [25, 50],
          iconUrl: this.pinsImgURLs['circlePin'],
        })
      }),
    dots:
      marker([0, 0], {
        icon: icon({
          iconSize: [this.iconSize.width, this.iconSize.height],
          iconAnchor: [25, 50],
          iconUrl: this.pinsImgURLs['dotsPin'],
        })
      })
  }

  public layers = [
    tileLayer(
      //'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      'https://tms{s}.visicom.ua/2.0.0/world,ua/base/{z}/{x}/{y}.png', {
      attribution: "Дані карт © 2022 АТ «<a href='https://api.visicom.ua/'>Візіком</a>»", //'&copy; OpenStreetMap contributors',
      subdomains: "123",
      maxZoom: 19,
      tms: true
    })
  ];
  /*
  layers: [
      new L.TileLayer("https://tms{s}.visicom.ua/2.0.0/planet3/base/{z}/{x}/{y}.png", {
          attribution: "Данные карт © 2019 ЧАО «<a href='https://api.visicom.ua/'>Визиком</a>»",
          subdomains: "123",
          maxZoom: 19,
          tms: true
      })
  ]
  */
  //public center = latLng([49.979966, 33.656909]); //myrhor
  public center = latLng([48.979966, 28.656909]);
  public options = {
    layers: this.layers,
    //zoom: 12,
    zoom: 6,
    center: this.center
  };

  public hiddenMarkerOptions = JSON.parse(JSON.stringify(this.options));

  // end defaults

  public currentMessage = '';
  public isAnimationsEnabled: boolean;

  // public openCloseStatus


  constructor(
    private mapService: MapRendererService,
    private controller: RenderAndPreviewControllerService,
    private clearData: ClearDataService) {

    Object.freeze(this.pinsImgURLs);
    Object.freeze(this.standartMarkers);
    Object.freeze(this.iconSize);

    this.isAnimationsEnabled = this.controller.getScreenWidth() > 743 ? true : false;

    this.mapService.getDrawOfficesSubject().asObservable().subscribe(newOfficesToDraw => {
      if (newOfficesToDraw) {
        this.currentOffices = newOfficesToDraw;
        this.makeMapEmpty();

        let markersForPostoffices = [];

        for (let office of newOfficesToDraw) {
          if (!(office.LATTITUDE && office.LONGITUDE)) continue;

          // Визначаємо тип піна за вашою новою функцією
          const pinType = this.getPinTypeByOffice(office);
          
          let markerForCurrentOffice = this.makeMarkerFromCoordinates(
            +office.LATTITUDE, 
            +office.LONGITUDE, 
            pinType, 
            false, // Малюємо всі як inactive спочатку
            office
          );

          if (markerForCurrentOffice) markersForPostoffices.push(markerForCurrentOffice);
        }

        let layer = this.createLayerFromMarkersArray(markersForPostoffices);
        layer.addTo(this.map);
        if (newOfficesToDraw.length === 1) {
          this.drawOnMapOffiseScaledUp(newOfficesToDraw[0]);
        }
      }
    });

    // FOCUS MAP ON POINT
    this.mapService.getFocusMapOnPointSubject().asObservable().subscribe(
      newPointToFocus => {
        if (newPointToFocus) {
          this.setFocus(newPointToFocus.point, newPointToFocus.zoom);

        }
      }
    )

    // focus (center) map at middle of many points 
    this.mapService.getFocusMapCenterAtMiddleOfManyPointsSubject().asObservable().subscribe((pointsArray: Array<[number, number]>) => {
      if (pointsArray) {
        this.focusMapAtMiddleOfManyPoints(pointsArray);

      }
    })

    // display error on map
    this.mapService.getShowErrorSubject().asObservable().subscribe((e: { isDisplay: boolean, messageText: string }) => {
      if (e) {
        //console.log('show error - ', e.isDisplay)
        if (e.isDisplay !== null && e.isDisplay !== undefined) {
          this.showError(e.isDisplay, e.messageText);
        }
    
      }
    });

    // focus map at some office from list 
    this.mapService.getFocusAtSpecialOfficeFromListSubject().asObservable().subscribe(officeToFocuseOn => {
      if (officeToFocuseOn) {
        this.drawOnMapOffiseScaledUp(officeToFocuseOn)

      }
    })

    this.controller.getSelectedOfficeDataSubject().asObservable().subscribe((newData: { officeChoosenFromList: PostOfficeInfo, officeChoosenOnMap: any, scaledUpMarkerFromList: any, scaledUpMarkerFromMap: any }) => {
      if (newData) {
        if (newData.officeChoosenOnMap) {
          //this.deleteScaledUpMarker()
          //console.log('from map', newData.officeChoosenOnMap)
          this.drawOnMapOffiseScaledUp(newData.officeChoosenOnMap)

        }
      }

    })

    // delete Scaled up marker
    this.mapService.getDeleteScaledUpMarkerSubject().asObservable().subscribe((isDelete) => {
      if (isDelete) {
        // for exapmle callsed by button back to offices list 

        //console.log('map: del scaledup ');
        this.deleteScaledUpMarker();

      }
    })

    // clear map 
    this.mapService.getClearMapSubject().asObservable().subscribe(toClear => {
      if (toClear) {
        this.makeMapEmpty();

      }
    })

    // clear map
    this.clearData.getClearSubject().asObservable().subscribe((whatToClear: { Map: boolean, Dropdown: boolean, previewList: boolean, previewSelected: boolean, clearMapMessage: boolean }) => {
      if (whatToClear) {
        //console.error(whatToClear)
        if (whatToClear.Map) {
          this.makeMapEmpty();
        }
        if (whatToClear.clearMapMessage) {
          this.isDisplayError = false; // add text = ""
        }
        if (whatToClear.previewList) {
          this.currentOffices = null;
          this.currentVPZ = null;
        }
      }
    })


  }//constructor





  ngOnInit() {

    // setTimeout(() => {
    //   //this.map.removeLayer( this.officeMarker )
    //   this.makeMapEmpty()
    // }, 500)

  }// on init



  public fixMapSize() { // used in html binding 
    this.map.invalidateSize()
  }

  public onMapReady(readyMap: L.Map) { // used in html binding 
    // general way to get map instance to work with it 
    this.map = readyMap;
  }

  // NEW MARKER ADDITION FUNCTION
  public makeMarkerFromCoordinates(latt: number, long: number, pinType: string, isActive: boolean = false, officeData?: PostOfficeInfo): L.Marker {
    if (!latt && !long) return null;

    const url = this.pinsImgURLs[pinType][isActive ? 'active' : 'inactive'];
    const size = isActive ? [44, 56] : [32, 42];

    const ic = icon({
      iconUrl: url,
      iconSize: [size[0], size[1]],
      iconAnchor: [size[0] / 2, size[1]],
      className: isActive ? 'active-pin' : 'inactive-pin'
    });

    const mar = marker([-(-latt), -(-long)], { icon: ic });
    
    // Зберігаємо дані офісу всередині маркера
    if (officeData) {
      (mar as any).officeData = officeData;
    }

    mar.on('click', () => { 
      this.selectedOfficeOnMap(mar);
    });

    return mar;
  }

  // NEW drawOnMapOffiseScaledUp
  private drawOnMapOffiseScaledUp(office: PostOfficeInfo) {
    if (office && office.LONGITUDE && office.LATTITUDE) {
      this.deleteScaledUpMarker();

      const pinType = this.getPinTypeByOffice(office);
      
      // Створюємо активний маркер
      let activeMarker = this.makeMarkerFromCoordinates(
        +office.LATTITUDE, 
        +office.LONGITUDE, 
        pinType, 
        true // Стан Active
      );

      if (activeMarker) {
        this.currentScaledUpMarker = activeMarker;
        this.currentScaledUpMarker.addTo(this.map);
        this.currentScaledUpMarker.setZIndexOffset(1000); // Поверх інших
      }
    }
  }

  public scaleUpMarker(latLong: [number, number]) {
    let latlng = this.currentScaledUpMarker && this.currentScaledUpMarker._latlng;
    if (this.currentScaledUpMarker == undefined || latlng && (latlng.lat != latLong[0] || latlng.lng != latLong[1])) {
      let markerForCurrentOffice = this.makeMarkerFromCoordinates(latLong[0], latLong[1], 'circle', true);
      if (markerForCurrentOffice) {
        this.currentScaledUpMarker = markerForCurrentOffice;
        //console.log(" /*/*/*/*/*/*/*/ ", this.currentScaledUpMarker)
        let layer = this.createLayerFromMarkersArray([markerForCurrentOffice]);
        this.controller.setScaledUpMarkerFromList(layer) //changed for check
        //this.scaledUpMarkerFromList = layer;


        layer.addTo(this.map);
      }
    }
    //this.focusMapAtMiddleOfManyPoints([latLang]);
  }



  public deleteScaledUpMarker() {
    if (this.currentScaledUpMarker) {
      this.map.removeLayer(this.currentScaledUpMarker);
      this.currentScaledUpMarker = null;
    }
  }

  public createLayerFromMarkersArray(markers: Array<L.Marker>): L.LayerGroup {
    return L.layerGroup(markers);
  }


  public makeMapEmpty() {
    // map.removeLayer(layer)
    if (this.map) {
      this.map.eachLayer((currentLayer) => {
        let isLabelLayer = !!(currentLayer && (currentLayer as any).options ? (currentLayer as any).options.attribution : '')
        if (!isLabelLayer) { // delete layers except map label 
          this.map.removeLayer(currentLayer)
        }
      })
    }
  }


  public setFocus(latLng: [number, number], viewScale) {
    this.map.setView(latLng, viewScale);
    // e.target.getLatLng() 
  }

  public focusMapAtMiddleOfManyPoints(arrayOfPointsLatLng: Array<[number, number]>) {
    //let bounds = arrayOfPointsLatLng.getBounds() 
    //console.log(arrayOfPointsLatLng, 'ltlng 1')
    arrayOfPointsLatLng = arrayOfPointsLatLng.filter((point: any) => {
      //console.error(point[0] && point[1]);
      return (point[0] && point[1]); // dont draw points with null value of  coordinate 
    })
    //console.log(arrayOfPointsLatLng, 'ltlng')
    let bounds = new L.LatLngBounds(arrayOfPointsLatLng);
    this.map.fitBounds(bounds);
  }

  public showError(toShow: boolean, message: string = '') {
    if (toShow === true || toShow === false) {
      this.isDisplayError = toShow;
      this.currentMessage = message;
    }
  }

  public selectedOfficeOnMap(mapObject: any) {
    //console.log(mapObject._latlng, ([mapObject._latlng.lat, mapObject._latlng.lng]))
    this.controller.setOfficeSelectedOnMap([mapObject._latlng.lat, mapObject._latlng.lng])
  }

}
